import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["id", "checked", "defaultChecked", "onChange", "name", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import l, { Fragment as k, createContext as x, useContext as A, useMemo as w, useRef as H, useState as F, useEffect as M } from "react";
import { forwardRefWithAs as _, render as E, compact as U } from '../../utils/render.js';
import { useId as K } from '../../hooks/use-id.js';
import { Keys as P } from '../keyboard.js';
import { isDisabledReactIssue7711 as B } from '../../utils/bugs.js';
import { Label as I, useLabels as O } from '../label/label.js';
import { Description as W, useDescriptions as N } from '../description/description.js';
import { useResolveButtonType as J } from '../../hooks/use-resolve-button-type.js';
import { useSyncRefs as X } from '../../hooks/use-sync-refs.js';
import { Hidden as j, Features as $ } from '../../internal/hidden.js';
import { attemptSubmit as q } from '../../utils/form.js';
import { useEvent as u } from '../../hooks/use-event.js';
import { useControllable as z } from '../../hooks/use-controllable.js';
import { useDisposables as Q } from '../../hooks/use-disposables.js';
var b = x(null);
b.displayName = "GroupContext";
var V = k;

function Y(p) {
  var t;

  var _F = F(null),
      _F2 = _slicedToArray(_F, 2),
      n = _F2[0],
      c = _F2[1],
      _O = O(),
      _O2 = _slicedToArray(_O, 2),
      d = _O2[0],
      m = _O2[1],
      _N = N(),
      _N2 = _slicedToArray(_N, 2),
      r = _N2[0],
      f = _N2[1],
      a = w(function () {
    return {
      switch: n,
      setSwitch: c,
      labelledby: d,
      describedby: r
    };
  }, [n, c, d, r]),
      h = {},
      T = p;

  return l.createElement(f, {
    name: "Switch.Description"
  }, l.createElement(m, {
    name: "Switch.Label",
    props: {
      htmlFor: (t = a.switch) == null ? void 0 : t.id,
      onClick: function onClick(o) {
        n && (o.currentTarget.tagName === "LABEL" && o.preventDefault(), n.click(), n.focus({
          preventScroll: !0
        }));
      }
    }
  }, l.createElement(b.Provider, {
    value: a
  }, E({
    ourProps: h,
    theirProps: T,
    defaultTag: V,
    name: "Switch.Group"
  }))));
}

var Z = "button";

function ee(p, n) {
  var c = K(),
      _p$id = p.id,
      d = _p$id === void 0 ? "headlessui-switch-".concat(c) : _p$id,
      m = p.checked,
      _p$defaultChecked = p.defaultChecked,
      r = _p$defaultChecked === void 0 ? !1 : _p$defaultChecked,
      f = p.onChange,
      a = p.name,
      h = p.value,
      T = _objectWithoutProperties(p, _excluded),
      t = A(b),
      o = H(null),
      D = X(o, n, t === null ? null : t.setSwitch),
      _z = z(m, f, r),
      _z2 = _slicedToArray(_z, 2),
      i = _z2[0],
      s = _z2[1],
      y = u(function () {
    return s == null ? void 0 : s(!i);
  }),
      g = u(function (e) {
    if (B(e.currentTarget)) return e.preventDefault();
    e.preventDefault(), y();
  }),
      C = u(function (e) {
    e.key === P.Space ? (e.preventDefault(), y()) : e.key === P.Enter && q(e.currentTarget);
  }),
      L = u(function (e) {
    return e.preventDefault();
  }),
      v = w(function () {
    return {
      checked: i
    };
  }, [i]),
      G = {
    id: d,
    ref: D,
    role: "switch",
    type: J(p, o),
    tabIndex: 0,
    "aria-checked": i,
    "aria-labelledby": t == null ? void 0 : t.labelledby,
    "aria-describedby": t == null ? void 0 : t.describedby,
    onClick: g,
    onKeyUp: C,
    onKeyPress: L
  },
      R = Q();

  return M(function () {
    var S;
    var e = (S = o.current) == null ? void 0 : S.closest("form");
    e && r !== void 0 && R.addEventListener(e, "reset", function () {
      s(r);
    });
  }, [o, s]), l.createElement(l.Fragment, null, a != null && i && l.createElement(j, _objectSpread({
    features: $.Hidden
  }, U({
    as: "input",
    type: "checkbox",
    hidden: !0,
    readOnly: !0,
    checked: i,
    name: a,
    value: h
  }))), E({
    ourProps: G,
    theirProps: T,
    slot: v,
    defaultTag: Z,
    name: "Switch"
  }));
}

var te = _(ee),
    ne = Y,
    ve = Object.assign(te, {
  Group: ne,
  Label: I,
  Description: W
});

export { ve as Switch };